<template>
	<div>
		<h1 v-tr="'landingpage_heading_membership'" class="mia-Heading" />
		<p v-tr="'landingpage_membershippanel_description'" class="mia-description" />
		<div class="mia-satisfactionGuaranteedSection">
			<tippy :placement="isDesktop ? 'left' : 'top'" trigger="click" :offset="[0, 0]">
				<span class="mia-satisfactionGuaranteed">
					<responsive-image :from="satisfactionGuaranteedIcon" />
					<span v-tr="'satisfactionguaranteed_title'" class="col-xs-30" />
				</span>
				<template #content>
					<span v-tr="'landingpage_membershippanel_satisfactionguaranteed_tooltip'" />
				</template>
			</tippy>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "../../../Reinforced.Typings";
import { ScreenSize } from "../../../utils/ScreenSize";
import ResponsiveImage from "@/Control/Vue/ResponsiveImage";
import { Tippy } from "vue-tippy";

@Component({
	components: {
		ResponsiveImage,
		Tippy,
	},
})
export class MembershipDescription extends Vue {
	@Prop({ required: true }) satisfactionGuaranteedIcon!: MiaPlaza.Navigation.JSON.Converters.ILazySizes;

	get isDesktop() {
		return ScreenSize.isDesktop();
	}
}

export default toNative(MembershipDescription);
</script>
